import { render, staticRenderFns } from "./ClientCheckFullReport.vue?vue&type=template&id=37c1e01a&scoped=true"
import script from "./ClientCheckFullReport.vue?vue&type=script&lang=js"
export * from "./ClientCheckFullReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c1e01a",
  null
  
)

export default component.exports